export default {"src":"/login-app/[GIT_HASH]/_next/static/media/failure_trend.cdbdf93f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};